import { Box, componentStyles, Text } from "@mallardbay/lib-react-components"
import React from "react"

import { formatEnumToTitleCase } from "~utils/formatting-helpers"

export default function ResourceInfoItem({
    title,
    value,
}: {
    readonly title?: string
    readonly value?: string | number | null
}) {
    const styles = useStyles()
    if (!value) return null

    const formattedValue =
        typeof value === "number"
            ? value.toString()
            : formatEnumToTitleCase(value)

    const formattedTitle = getTitle({ title })

    return (
        <Box style={styles.descriptionContainer}>
            <Text style={styles.title}>{formattedTitle}</Text>
            <Text>{formattedValue}</Text>
        </Box>
    )
}

function useStyles() {
    return componentStyles({
        title: {
            fontWeight: 700,
            marginBottom: 0.5,
            marginTop: 1,
        },
        descriptionContainer: {
            marginBottom: 2,
        },
    })
}

function getTitle({ title }: { title?: string }) {
    return `${formatEnumToTitleCase(title)}:`
}
